import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LectureDashboard() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Fetch user data from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/"); // redirect to login
  };

  const handleViewQuestionBank = () => {
    navigate("/create-question"); // ✅ go to Question Bank page
  };
  const handleViewAllQuestions = () => {
  navigate("/my-questions"); // ✅ go to question listing page
};


  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      {user ? (
        <div className="bg-white shadow-lg rounded-xl p-8 w-[400px] text-center">
          <h1 className="text-2xl font-bold text-blue-700 mb-2">
            Welcome, {user.name} 👋
          </h1>
          <p className="text-gray-600 mb-2">Role: {user.role}</p>
          <p className="text-gray-600 mb-6">Email: {user.email}</p>

          {/* ✅ View Question Bank Button */}
          <button
            onClick={handleViewQuestionBank}
            className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow-md hover:bg-blue-700 transition-all"
          >
            Create Question
          </button>


          <button
  onClick={handleViewAllQuestions}
  className="bg-green-600 text-white px-5 py-2 rounded-lg shadow-md hover:bg-green-700 transition-all mt-3"
>
  View Your Created Questions
</button>

          {/* ✅ Logout Button */}
          <button
            onClick={handleLogout}
            className="ml-3 bg-red-500 text-white px-5 py-2 rounded-lg shadow-md hover:bg-red-600 transition-all"
          >
            Logout
          </button>
        </div>
      ) : (
        <p className="text-gray-500 text-lg">Loading your dashboard...</p>
      )}
    </div>
  );
}
